var _rect, _rect2, _path;
var _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
import React from "react";
var SvgSilverIncentiveIcon = function SvgSilverIncentiveIcon(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 55,
    rx: 27.5,
    fill: "#E4ECF1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 55,
    rx: 27.5,
    stroke: "#8F9AA2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 18H33V25.85C33 26.2333 32.9167 26.575 32.75 26.875C32.5833 27.175 32.35 27.4167 32.05 27.6L28.5 29.7L29.2 32H33L29.9 34.2L31.1 38L28 35.65L24.9 38L26.1 34.2L23 32H26.8L27.5 29.7L23.95 27.6C23.65 27.4167 23.4167 27.175 23.25 26.875C23.0833 26.575 23 26.2333 23 25.85V18ZM25 20V25.85L27 27.05V20H25ZM31 20H29V27.05L31 25.85V20Z",
    fill: "#596975"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSilverIncentiveIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/silver-incentive-icon.dac76b1a.svg";
export { ForwardRef as ReactComponent };